import { createSelector } from 'reselect';
// import debounce from 'lodash.debounce';

import ModelModuleModel from 'src/model/modules/model.model';
import DiagramModel from 'src/model/diagram.model';
import ProductModel from 'src/model/product.model';

const moduleSel = (state: any): ModelModuleModel => state.model;

export const modelSel = (state: any) => moduleSel(state);
export const getModelIsPendingSel = (state: any): boolean =>
  moduleSel(state).getModelIsPending;

export const idSel = (state: any): number => moduleSel(state).id;
export const modelIDSel = (state: any): number => moduleSel(state).modelID;
export const diagramsSel = (state: any): DiagramModel[] =>
  moduleSel(state).diagrams;
export const commonPartsSel = (state: any): DiagramModel[] =>
  moduleSel(state).commonParts;
export const featuredProductsSel = (state: any): ProductModel[] =>
  moduleSel(state).featuredProducts;
export const modelNumberSel = (state: any): number =>
  moduleSel(state).modelNumber;
export const modelNameSel = (state: any): number => moduleSel(state).modelName;
export const manufacturerSel = (state: any): string =>
  moduleSel(state).manufacturer;
export const brandNameSel = (state: any): string => moduleSel(state).brandName;
export const applianceTypeSel = (state: any): string =>
  moduleSel(state).applianceType;
export const productionNumberSel = (state: any): string =>
  moduleSel(state).productionNumber;
export const textFilterSel = (state: any): string =>
  moduleSel(state).textFilter;
export const activeDiagramSel = (state: any): number =>
  moduleSel(state).activeDiagram;
export const activePartSel = (state: any): ProductModel | null =>
  moduleSel(state).activePart;

export const diagramsProductsSel = createSelector(diagramsSel, diagrams => {
  const allProducts: ProductModel[] = [];
  diagrams.map(item => {
    allProducts.push.apply(allProducts, item.products);
  });
  return allProducts;
});
